module.exports = __webpack_public_path__ + "img/5bf8aeae7d4a9e08e12eb21d5bf1baa4.png";